// Mock data para Patas Club Veterinaria & Petshop

export const businessInfo = {
  name: "Patas Club Veterinaria & Petshop",
  slogan: "Cuidamos a quienes más amás",
  address: "Combate de Los Pozos 730, C1222AAF",
  city: "Ciudad Autónoma de Buenos Aires, Argentina",
  phone: "+54 9 11 6257-3889",
  whatsapp: "5491162573889",
  hours: "Lunes a Viernes: 10:00-14:00 y 16:00-18:00 | Sábados: 10:00-14:00",
  rating: 5.0,
  totalReviews: 59,
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.7564883387855!2d-58.39587092463755!3d-34.60754675788649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccac7fbc8c731%3A0x4f7c7a8a3e8b3e8b!2sCombate%20de%20Los%20Pozos%20730%2C%20C1222AAF%20CABA%2C%20Argentina!5e0!3m2!1ses!2sar!4v1234567890123!5m2!1ses!2sar"
};

export const services = [
  {
    id: 1,
    title: "Clínica General",
    description: "Atención veterinaria completa para el diagnóstico y tratamiento de enfermedades de tu mascota.",
    icon: "stethoscope"
  },
  {
    id: 2,
    title: "Vacunación",
    description: "Planes de vacunación completos para proteger a tu mascota de enfermedades.",
    icon: "syringe"
  },
  {
    id: 3,
    title: "Desparasitación",
    description: "Tratamientos preventivos y curativos contra parásitos internos y externos.",
    icon: "shield"
  },
  {
    id: 4,
    title: "Consultas Preventivas",
    description: "Chequeos regulares para que tu compañerito esté siempre bárbaro.",
    icon: "heart-pulse"
  },
  {
    id: 5,
    title: "Atención Personalizada",
    description: "Cada mascota es única y merece un trato muy especial y cariñoso.",
    icon: "paw-print"
  },
  {
    id: 6,
    title: "Cirugía",
    description: "Procedimientos quirúrgicos realizados con equipamiento moderno y cuidado profesional.",
    icon: "activity"
  }
];

export const specialties = [
  {
    id: 1,
    title: "Ecografía",
    icon: "scan"
  },
  {
    id: 2,
    title: "Oftalmología",
    icon: "eye"
  },
  {
    id: 3,
    title: "Cardiología",
    icon: "heart"
  },
  {
    id: 4,
    title: "Radiografía",
    icon: "radio"
  },
  {
    id: 5,
    title: "Atención Animales Exóticos",
    icon: "bird"
  },
  {
    id: 6,
    title: "Dermatología",
    icon: "droplet"
  },
  {
    id: 7,
    title: "Ozonoterapia",
    icon: "wind"
  },
  {
    id: 8,
    title: "Odontología",
    icon: "smile"
  },
  {
    id: 9,
    title: "Medicina Felina",
    icon: "cat"
  },
  {
    id: 10,
    title: "Traumatología",
    icon: "bone"
  }
];

export const petshopProducts = [
  {
    id: 1,
    category: "Peluquería Canina",
    description: "Servicio de grooming profesional: baño, corte, cepillado y estética para que tu mascota luzca hermosa.",
    icon: "scissors"
  },
  {
    id: 2,
    category: "Accesorios",
    description: "Collares, pretales, correas y todo lo que necesitás para pasear con tu mascota.",
    icon: "shirt"
  },
  {
    id: 3,
    category: "Juguetes",
    description: "Una gran variedad de juguetes para que tu mascota esté siempre activa y feliz.",
    icon: "toy-brick"
  },
  {
    id: 4,
    category: "Camas y Confort",
    description: "Camas, mantas y accesorios para que tu compañero descanse súper bien.",
    icon: "bed"
  },
  {
    id: 5,
    category: "Higiene",
    description: "Productos de limpieza, shampoos y accesorios de higiene para mascotas.",
    icon: "sparkles"
  },
  {
    id: 6,
    category: "Comederos y Bebederos",
    description: "Comederos y bebederos de diferentes tamaños y materiales.",
    icon: "circle-dot"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Jazmín Villar",
    text: "Genesis fue la primera veterinaria de mi perra cuando tenía 4 meses, y ahora con 4 años, sigue siendo ella! Eso lo dice todo; es la persona más empática y amorosa del mundo. Siempre dispuesta a responder cualquier duda que tengas. ¡Gracias, Vet! 🫶🏻✨",
    rating: 5
  },
  {
    id: 2,
    name: "Paola Tenca",
    text: "¡Genesis es una veterinaria excelente! Cuida a Homer desde que lo rescatamos hace casi 6 años! Y a Junior también! ¡Vino varias veces a casa para atenderlos! ¡No tenemos más que palabras de agradecimiento! Es un amor y tiene una paciencia infinita! ¡Muy dedicada y siempre dispuesta a recibir a los perros que rescatamos!",
    rating: 5
  },
  {
    id: 3,
    name: "Camila Gnemmi",
    text: "¡Elegiría mil veces a Genesis como mi veterinaria! Es un genio, humana, empática, con una paciencia increíble y un amor enorme por los animales. Se nota que tiene vocación. Me da muchísima tranquilidad que Conan y Donna estén en sus manos.",
    rating: 5
  },
  {
    id: 4,
    name: "Oswaldo Santos Benain",
    text: "¡Excelente profesional! La Dra. Genesis demuestra gran cariño por sus pacientes, siempre buscando actualizarse y brindar la mejor atención. Además es muy completa, ya que no solo es clínica general sino también una excelente cirujana.",
    rating: 5
  },
  {
    id: 5,
    name: "Lauly Gangy",
    text: "Es un lugar increíble porque tienen todo lo que necesitás y no tenés que ir a varios lugares diferentes, pero lo que realmente lo hace especial es el maravilloso personal, desde las personas que bañan a nuestros peludos hasta la veterinaria.",
    rating: 5
  },
  {
    id: 6,
    name: "ELSA TL",
    text: "Me encanta el carisma de Genesis con sus pacientes y con los que nos hacemos llamar Mamá o Papá Peludo. Es sincera, sensible y muy buena profesional. ¡Gracias!",
    rating: 5
  }
];

export const aboutInfo = {
  title: "Sobre Nosotros",
  description: "En Patas Club, entendemos que tu mascota es parte de tu familia. Por eso, ofrecemos atención veterinaria de calidad con un enfoque en el trato amoroso, la empatía y la atención personalizada.",
  mission: "Nuestra misión es brindar el mejor cuidado posible para tus compañeros peludos, combinando profesionalismo médico con un trato muy cálido y humano.",
  team: "Nuestro equipo está liderado por la veterinaria Genesis, quien se caracteriza por su dedicación, empatía y amor incondicional hacia los animales. Con años de experiencia, Genesis se asegura de que cada mascota reciba la atención que merece."
};